// eslint-disable-next-line no-unused-vars
import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useRef, useState } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

const UsageChartKpi = ({ items = [] }) => {
  const [page, setPage] = useState(0)
  const [direction, setDirection] = useState(0)

  const intervalRef = useRef(null)

  const totalPages = Math.ceil(items.length / 3)

  const currentItems = items.slice(page * 3, (page + 1) * 3)

  const startAutoSlide = () => {
    clearInterval(intervalRef.current)

    intervalRef.current = setInterval(() => {
      setDirection(1)

      setPage((prev) => (prev === totalPages - 1 ? 0 : prev + 1))
    }, 5000)
  }

  useEffect(() => {
    if (totalPages <= 1) return

    startAutoSlide()

    return () => clearInterval(intervalRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages])

  const handlePageChange = (newPage, newDirection) => {
    setDirection(newDirection)
    setPage(newPage)

    startAutoSlide()
  }

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 50 : -50,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir) => ({
      x: dir > 0 ? -50 : 50,
      opacity: 0
    })
  }

  if (!items.length) return null

  return (
    <div
      className="
        mt-4 h-13 px-6 py-3 overflow-hidden
        flex items-center justify-between
        rounded-xl border border-gray-100 bg-gray-50
      "
    >
      <div className="relative flex h-full flex-1 items-center">
        <AnimatePresence initial={false} custom={direction} mode="wait">
          <motion.div
            key={page}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              duration: 0.2,
              ease: "easeInOut"
            }}
            className="absolute w-full flex items-center justify-start gap-12"
          >
            {currentItems.map((item, idx) => (
              <div key={item.title} className="flex items-center min-w-45 gap-3">
                <span className="text-sm font-medium text-gray-500">{item.title}</span>

                <span className={`text-base font-bold ${item.accent}`}>{item.value}</span>

                {idx < currentItems.length - 1 && <div className="ml-auto h-3 w-px bg-gray-300" />}
              </div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

      {totalPages > 1 && (
        <div className="z-10 flex select-none items-center gap-3 border-l border-gray-200 pl-4">
          <span className="tabular-nums text-xs font-medium text-gray-400">
            {page + 1} / {totalPages}
          </span>

          <div className="flex gap-1">
            <button
              onClick={() => handlePageChange(page === 0 ? totalPages - 1 : page - 1, -1)}
              className="cursor-pointer rounded p-1 transition-colors hover:bg-gray-200"
            >
              <ChevronLeft size={16} className="text-gray-600" />
            </button>

            <button
              onClick={() => handlePageChange(page === totalPages - 1 ? 0 : page + 1, 1)}
              className="cursor-pointer rounded p-1 transition-colors hover:bg-gray-200"
            >
              <ChevronRight size={16} className="text-gray-600" />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default UsageChartKpi
